import {from as observableFrom, Observable} from 'rxjs';
import {map, mergeMap} from 'rxjs/operators';
import {Component, OnInit, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {
    AssistanceApplication,
    AssistanceApplicationType,
    Client,
    EfnCase,
    KcApplicationResult,
    Pledge,
    User
} from '../../../services/api.client';
import {ClientService} from '../../../services/ClientService';
import {PledgeService} from '../../../services/PledgeService';
import {SystemService} from '../../../services/SystemService';
import {EfnService} from '../../../services/EfnService';
import {KcApplicationService} from '../../../services/KcApplicationService';
import {SecurityService} from '../../../services/SecurityService';
import {environment} from '../../../../environments/environment';
import {AssistanceApplicationService} from '../../public/application/assistance-application.service';

@Component({
    templateUrl: './ClientTabsComponent.html',
    styleUrls: ['./ClientTabsComponent.scss'],
    standalone: false
})

export class ClientTabsComponent implements OnInit, OnDestroy {

    constructor(private _route: ActivatedRoute,
                private _router: Router,
                private _clientService: ClientService,
                private _pledgeService: PledgeService,
                public system: SystemService,
                private efnService: EfnService,
                private assistanceApplicationService: AssistanceApplicationService,
                private _kcApplicationService: KcApplicationService,
                private _securityService: SecurityService) {
        this.currentUser$ = this._securityService.currentUser$;
        this.currentClient$ = this._clientService.currentClient$;
        this.currentClientPledgeList$ = this._pledgeService.currentClientPledgeList$;
        this.clientEfnCases$ = this.efnService.clientsEfnCases$;
        this.applicationResult$ = this._kcApplicationService.currentKcApplicationResult$;
    }

    get isClientEdit(): boolean {
        return this._router.url.indexOf('/edit') !== -1;
    }
    currentClient: Client;
    currentClient$: Observable<Client>;

    currentUser: User;
    currentUser$: Observable<User>;

    currentClientPledgeList: Pledge[];
    currentClientPledgeList$: Observable<Pledge[]>;

    clientEfnCases: EfnCase[];
    clientEfnCases$: Observable<EfnCase[]>;

    clientAssistanceApplications: AssistanceApplication[];
    clientAssistanceApplications$: Observable<AssistanceApplication[]>;

    applicationResult: KcApplicationResult;
    applicationResult$: Observable<KcApplicationResult>;

    protected readonly AssistanceApplicationType = AssistanceApplicationType;

    public showAssistanceApp(assistanceApplicationType: AssistanceApplicationType): boolean {
        return this.assistanceApplicationService.hasAccess(assistanceApplicationType, this.currentUser)
            && !environment.appConfig?.disableApplicationsFeature;
    }

    ngOnInit(): void {
        this.currentUser$.subscribe(user => this.currentUser = user);
        this.currentClient$.subscribe(currentClient => this.currentClient = currentClient);
        this.currentClientPledgeList$.subscribe(currentClientPledgeList => this.currentClientPledgeList = currentClientPledgeList);
        this.clientEfnCases$.subscribe(efnCases => this.clientEfnCases = efnCases);
        this.applicationResult$.subscribe(applicationResult => this.applicationResult = applicationResult);
        this.getCurrentClient().pipe(
            mergeMap((client) => this._pledgeService.getCurrenClientPledgeList(client.id) && this.efnService.getEfnCasesByClientId(client.id)))
            .subscribe();
    }

    getCurrentClient(): Observable<Client | null> {
        if (this.currentClient) {
            return observableFrom([this.currentClient]);
        }
        return this._route.params.pipe(
            map(params => params.id),
            mergeMap((id) => this._clientService.getClientById(id)));
    }

    ngOnDestroy(): void {
        this._clientService.setCurrentClientAction(null);
    }
}
